import { I18n } from '@calendly/i18n';
import { ContextualBanner } from '@calendly/ui/components/contextual-banner';
import { AlertWarningTriangleIcon, ArrowRoundRightIcon, ArrowSyncIcon } from '@calendly/ui/components/icons';
import { MinimalButton } from '@calendly/ui/components/minimal-button';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { useCallback, forwardRef } from 'react';
import { useHistory } from 'react-router-dom';
import { selectById as selectCalendarConnectionById, useConnectOauthMutation, useFetchCalendarAccountsQuery } from 'features/calendar_connections';
import { CALENDAR_CONNECTIONS_POPUP_ROUTE } from '../constants';
import { getCalendarSettingsReturnTo, isCalendarSettingsModalOpen } from '../oauth_return_path';
const CONNECTION_ERROR = {
  serverError: 'calendar_server_error',
  accessRevoked: 'calendar_access_revoked'
};
const wrapperCss = "wn86bvc";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
export const Error = ({
  accountId
}) => {
  const history = useHistory();
  const [connectOauth, {
    isLoading
  }] = useConnectOauthMutation();
  const {
    data,
    refetch
  } = useFetchCalendarAccountsQuery();
  const {
    name,
    kind: provider,
    error
  } = selectCalendarConnectionById(data, accountId);
  const onClickHandler = useCallback(() => {
    switch (error) {
      case CONNECTION_ERROR.serverError:
        return refetch();
      case CONNECTION_ERROR.accessRevoked:
        if (['google', 'outlook'].includes(provider)) {
          return connectOauth({
            provider,
            calendarAccountId: accountId,
            ...(isCalendarSettingsModalOpen() && {
              returnTo: getCalendarSettingsReturnTo()
            })
          });
        }
        if (provider === 'exchange') {
          return history.push(CALENDAR_CONNECTIONS_POPUP_ROUTE.getNewExchangePath(accountId));
        }
        if (provider === 'icloud') {
          return history.push(CALENDAR_CONNECTIONS_POPUP_ROUTE.getIcloudPath(accountId));
        }
        return Promise.resolve(false);
      default:
        return Promise.resolve(false);
    }
  }, [error, connectOauth, history, provider, accountId, refetch]);
  if (!Object.values(CONNECTION_ERROR).includes(error)) return null;
  return <ContextualBanner variant="danger" icon={AlertWarningTriangleIcon}>
      <Wrapper>
        <BodyText>
          {CONNECTION_ERROR.serverError === error && I18n.t('publisher.availability_settings.section.calendar_settings.errors.servers_are_unavailable', {
          name
        })}
          {CONNECTION_ERROR.accessRevoked === error && I18n.t('publisher.availability_settings.section.calendar_settings.errors.connection')}
        </BodyText>
        <MinimalButton onClick={onClickHandler} loading={isLoading}>
          {CONNECTION_ERROR.serverError === error && <>
            <ArrowSyncIcon />
            {' '}
            {I18n.t('errors.messages.try_again')}
          </>}
          {CONNECTION_ERROR.accessRevoked === error && <>
            <ArrowRoundRightIcon />
            {' '}
            {I18n.t('publisher.action.reconnect')}
          </>}
        </MinimalButton>
      </Wrapper>
    </ContextualBanner>;
};

require("./error.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./error.js");